
import React from 'react';
import { useTranslation } from 'react-i18next';
import TimeSelect from './TimeSelect';

interface TimePickerProps {
  hour: string;
  minute: string;
  onTimeChange: (hour: string, minute: string) => void;
}

const TimePicker: React.FC<TimePickerProps> = ({
  hour,
  minute,
  onTimeChange,
}) => {
  const { t } = useTranslation(['common']);
  
  // Generate time options
  const generateOptions = (max: number) => {
    return Array.from({ length: max }, (_, i) => {
      return i.toString().padStart(2, '0');
    });
  };
  
  const hours = generateOptions(24);
  const minutes = generateOptions(60);
  
  return (
    <div className="flex items-center justify-center gap-4">
      <TimeSelect
        label={t('common:hour')}
        options={hours}
        value={hour}
        onChange={(newHour) => onTimeChange(newHour, minute)}
      />
      
      <TimeSelect
        label={t('common:minute')}
        options={minutes}
        value={minute}
        onChange={(newMinute) => onTimeChange(hour, newMinute)}
      />
    </div>
  );
};

export default TimePicker;
